// The gate curtain — runtime controls.
//
// The (app) shell is PRERENDERED static HTML that paints before any client JS
// runs, so on a cold load no React guard can stop the office chrome from
// flashing. The curtain is an opaque, branded cover baked into that HTML (see
// <GateCurtain/>); it is DOWN in the served bytes and stays down until
// AuthGuard delivers a verdict.
//
// There is deliberately NO local "this browser already passed" cache: an
// earlier version lifted the curtain pre-paint from a localStorage mark, and
// the mark lied the moment an account was deleted out-of-band (founder,
// 08-03: chrome flashed for a dead login). A cache must never gate
// correctness — the only authority that may lift the curtain is a live
// verdict. In-app remounts stay instant via AuthGuard's in-memory session
// cache; the curtain cost is one branded beat per cold document load.

import { traceFlash } from "@/lib/flash-trace";

export const GATE_KNOWN_ATTR = "data-gate-known";

/** Hide the curtain — call only when a verdict exists for this mount. */
export function liftGateCurtain(): void {
  traceFlash("curtain_up");
  document.documentElement.setAttribute(GATE_KNOWN_ATTR, "");
}

/** Show the curtain (sign-out teardown, dead-session bounce, pre-verdict). */
export function lowerGateCurtain(): void {
  traceFlash("curtain_down");
  document.documentElement.removeAttribute(GATE_KNOWN_ATTR);
}
